module.exports = __webpack_public_path__ + "media/images/flags/32/Vatican-City-0a2b089fceee2b96916b2de2fcf4944b.png";